<form class="example-form" style="height:500px; width:400px">
          <mat-form-field class="example-full-width">
            <mat-label>Message</mat-label>
            <input matInput #message maxlength="256" placeholder="Ex. I need help with...">
            <mat-hint align="start"><strong>Don't disclose personal info</strong> </mat-hint>
            <mat-hint align="end">{{message.value.length}} / 256</mat-hint>
          </mat-form-field>
        </form>
